export enum DurationPropertyEnum {
  VALUE = 'value',
  UNIT = 'unit',
}
